import { render, staticRenderFns } from "./FreightTableSummary.vue?vue&type=template&id=9eea7802&scoped=true"
import script from "./FreightTableSummary.vue?vue&type=script&lang=js"
export * from "./FreightTableSummary.vue?vue&type=script&lang=js"
import style0 from "./FreightTableSummary.vue?vue&type=style&index=0&id=9eea7802&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eea7802",
  null
  
)

export default component.exports